import React from "react";
import { DraftItemProps, formatCustomTimestamp, getInitials } from "../../utils/common";
import { Card, CardHeader, CardBody, Tooltip } from "@material-tailwind/react";
import Avatar from "../../design-system/Avatar";
import styles from "../../components/SeedItem/SeedItem.module.css";
import { useNavigate } from "react-router-dom";
import { FaLock } from "react-icons/fa6";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { FaCheckCircle } from "react-icons/fa";
import { markdownComponents } from "../../pages/thoughts/chat/RenderResponse";

export function cleanTitle(title: string) {
    const titleString = title.toString().replace(/_/g, " ");
    if (titleString.includes("-")) {
        return titleString.split("-").slice(0, -1).join("-");
    } else {
        return titleString;
    }
}

function ShowPublishedExclusiveItemInSeedSearch({ draft, onCitationClick }: DraftItemProps & { onCitationClick: any }) {
    const navigate = useNavigate();

    const openSpecificDraftClick = (fileName: String) => (event: React.MouseEvent<HTMLDivElement>) => {
        if (draft.draft) navigate(`/my-exclusive-content/draft/${fileName}`, { state: { fileName: fileName } });
        else navigate(`/my-exclusive-content/published/${fileName}`, { state: { fileName: fileName } });
    };
    function onCitationClicked(seed: any): void {
        if (onCitationClick) {
            onCitationClick(seed);
        }
    }
    const initials = getInitials(draft.author);

    return (
        //checking condition in onClick method because some old content contains id
        <div
            // onClick={!draft.file_name ? openSpecificDraftClick(draft.id) : openSpecificDraftClick(draft.file_name)}
            onClick={e => {
                e.preventDefault();
                onCitationClicked(draft);
            }}
            className="my-2 cursor-pointer hover:cursor-pointer "
        >
            <CardHeader className="relative">
                <div className={`${styles.header} p-1 text-gray-700`}>
                    <div className="flex items-center">
                        <Tooltip content={draft.author} className="bg-neutral-600 w-fit h-7 text-center p-1  top-full left-0 z-50" placement="right">
                            <div>
                                <Avatar initials={initials} className="mr-2" />
                            </div>
                        </Tooltip>
                    </div>
                    <span className={`justify-self-center truncate w-full max-w-full text-gray-500`}>
                        {draft.finalized_date ? formatCustomTimestamp(draft.finalized_date) : formatCustomTimestamp(draft.date)}
                    </span>
                    <h2 className={`justify-self-center font-title truncate w-full max-w-full`} title={draft.title}>
                        {cleanTitle(draft.title)}
                    </h2>
                    <div className="flex gap-4">
                        <Tooltip content="Exclusive Content" className="bg-neutral-600 w-fit h-7 text-center p-1  top-full left-0 z-50" placement="top">
                            <div>
                                <FaLock />
                            </div>
                        </Tooltip>
                        {draft.draft ? (
                            ""
                        ) : (
                            <Tooltip content="Published Content" className="bg-neutral-600 w-fit h-7 text-center p-1  top-full left-0 z-50" placement="top">
                                <div>
                                    <FaCheckCircle />
                                </div>
                            </Tooltip>
                        )}
                    </div>
                </div>
            </CardHeader>
            {/* <CardBody className="p-2 overflow-auto">
                <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]} components={markdownComponents}>
                    {draft.brief_summary}
                </ReactMarkdown>
            </CardBody> */}
        </div>
    );
}

export default ShowPublishedExclusiveItemInSeedSearch;
